import { getDate } from "@/helpers/date.helpers"

import type { HighProfileVulnerabilityDTO } from "@/domain/issue"

export const highProfileVulnerabilities: HighProfileVulnerabilityDTO[] = [
  {
    id: "__1",
    title:
      "FastMCP OpenAPI flaw lets AI agents reach internal services via SSRF",
    type: "affected" as const,
    riskIds: [
      {
        id: "CVE-2026-32871",
        publishedOn: getDate().unix(),
        aliases: [{ id: "GHSA-vv7q-7jx5-f767" }]
      }
    ],
    issues: 7,
    updatedAt: getDate().unix(),
    publishedOn: getDate().unix(),
    lastScanAt: 0,
    references: [
      {
        id: "1",
        label: "NVD",
        url: "https://nvd.nist.gov/vuln/detail/CVE-2026-32871"
      }
    ].map((reference) => ({
      hostname: new URL(reference.url).hostname,
      ...reference
    }))
  }
]
